<template>
  <div
    id="popGoodListWrapper"
    ref="container"
    v-pan:vertical.scroll="dragHandle"
    class="list-bar"
    :class="{ 'in-class-loading': inClassLoading }"
    @scroll.stop="scroll"
  >
    <ul ref="list" class="main-list">
      <li
        v-if="goodsList.list.length !== 0 && direction === 'up'"
        class="main-list-top"
        :style="{ height: computedHeight + 'px' }"
      >
        <p v-if="inClassLoading" class="list-loading">
          <img src="@/images/loading/loading.gif" width="18" />加载中
        </p>
        <p v-if="!inClassLoading">
          <img src="@/images/loading/loading.gif" width="18" />
          {{
            canGoPre
              ? computedHeight == 54
                ? '松开返回上一个分类'
                : '下拉返回上一个分类'
              : '已经到顶了'
          }}
        </p>
      </li>

      <div
        v-for="(item, index) in goodsList.list"
        :key="item.skuBase.skuId"
        v-expose-track="{
          popIndex: {
            mapId: 'popGoodExpose',
            data: {
              spm: $trackMap.pop.goodExpose,
              ...getTracerParams(item, index)
            }
          }
        }"
        class="li-container"
        :class="index === 0 ? 'first-li' : ''"
      >
        <SkuSingle
          v-if="item.ssuList.length === 1"
          :sku="item"
          :sku-index="index"
        />
        <SkuMutiple v-else :sku="item" :sku-index="index" />
      </div>
      <li
        v-if="goodsList.list.length !== 0 && direction === 'down'"
        class="main-list-nomore"
      >
        <p v-if="goodsList.ifFinished && canGoNext" class="last-tip">
          向上拖动，加载下一个分类
        </p>
        <p
          v-if="
            !goodsList.ifFinished || (goodsList.ifFinished && inClassLoading)
          "
          class="list-loading"
        >
          <img src="@/images/loading/loading.gif" width="18" />加载中
        </p>
        <p
          v-if="goodsList.ifFinished && !inClassLoading"
          :style="{ height: computedHeight + 'px' }"
          style="overflow: hidden"
        >
          <img src="@/images/loading/loading.gif" width="18" />
          {{
            canGoNext
              ? computedHeight == 54
                ? '松开加载上一个分类'
                : ''
              : '已经到底了'
          }}
        </p>
      </li>
    </ul>
    <!-- 商品列表加载loading -->
    <div v-show="loading" class="loading">
      <div class="load-img">
        <img class="circle" src="@/images/loading/circle.png" />
        <span class="loading-text">正在加载</span>
      </div>
    </div>
    <!-- 商品列表为空缺省图展示 -->
    <div v-if="empty" class="empty-list">
      <img src="@/images/empty/good.png" />
      <p>暂无菜品</p>
    </div>
  </div>
</template>

<script>
import SkuMutiple from './SkuMutiple.vue'
import SkuSingle from './SkuSingle.vue'

let inWorking = false

export default {
  components: {
    SkuMutiple,
    SkuSingle
  },
  props: [
    // eslint-disable-next-line vue/require-prop-types
    'goodsList',
    // eslint-disable-next-line vue/require-prop-types
    'parentNode',
    // eslint-disable-next-line vue/require-prop-types
    'class2Index',
    // eslint-disable-next-line vue/require-prop-types
    'class2List',
    // eslint-disable-next-line vue/require-prop-types
    'showSaleAreaGood',
    // eslint-disable-next-line vue/require-prop-types
    'saleClass2Id',
    // eslint-disable-next-line vue/require-prop-types
    'loading',
    // eslint-disable-next-line vue/require-prop-types
    'empty'
  ],
  data() {
    return {
      direction: 'down',
      inClassLoading: false,
      computedHeight: 0,
      canLoad: true, // loading中间状态
      isShowMask: false
    }
  },
  computed: {
    canGoPre: function () {
      return this.class2Index > 0
    },
    canGoNext: function () {
      return this.class2Index < this.class2List.length - 1
    },
    classIds: function () {
      const c2 = this.class2List[this.class2Index]
      return {
        class2Id: c2 && c2.id
      }
    },
    calcWidth() {
      const baseWidth = window.innerWidth * 2
      return Math.ceil((70 * 2 * baseWidth) / 750 / 2)
    }
  },
  watch: {
    goodsList: {
      handler: function (val, oldVal) {
        this.canLoad = true
        this.direction = 'down'
        this.inClassLoading = false
        this.computedHeight = 0
        // 对于下拉刷新，长度过小的时候需要自动触发刷新
        if (!val.ifFinished && val.list.length <= 6 && val.list.length !== 0) {
          this.checkReGet()
        }
      },
      deep: true
    }
  },
  methods: {
    getTracerParams(good, skuPos) {
      const ssu = good.ssuList[0]
      return {
        sku_id: good.skuBase.skuId || 0,
        sku_pos: skuPos,
        price: good?.priceSpm || '',
        str_sale_class2_id: String(this.classIds.class2Id || ''),
        goods_status: ssu?.status_remind_info?.goods_status || 0
      }
    },
    beforeAddcart(name) {
      this.$emit('beforeAddcart', name)
    },
    scroll(event) {
      if (!this.canLoad) return

      this.checkReGet()
    },
    checkReGet() {
      if (
        this.$el.scrollTop + this.$el.offsetHeight + 200 >
        this.$refs.list.offsetHeight
      ) {
        if (!this.goodsList.ifFinished) {
          this.canLoad = false
          this.$emit(
            'bottomReGet',
            Object.assign({}, this.goodsList.query, {
              page: this.goodsList.query.page
                ? this.goodsList.query.page + 1
                : 2
            })
          )
        }
      }
    },
    dragHandle({ event, dragDirection, delta, currentState }) {
      // 滑动
      if (currentState.state === 'MOVING') {
        // 正在下拉 或者 正在上拉
        if (dragDirection === 'DRAG_DOWN' || dragDirection === 'DRAG_UP') {
          let deltaY = Math.abs(delta.totalY)
          deltaY = Math.min(deltaY, 108)
          this.computedHeight = (54 * deltaY) / 108

          if (dragDirection === 'DRAG_DOWN') {
            this.direction = 'up'
          }
          if (dragDirection === 'DRAG_UP') {
            this.direction = 'down'
            this.$el.scrollTop = this.$el.scrollTop + this.computedHeight
          }
        }
      } else if (currentState.state === 'END') {
        if (
          dragDirection === 'DRAG_DOWN' &&
          delta.totalY >= 108 &&
          this.canGoPre
        ) {
          this.fetchAdjacent()
        } else if (
          dragDirection === 'DRAG_UP' &&
          delta.totalY <= -108 &&
          this.canGoNext
        ) {
          this.fetchAdjacent()
        } else {
          this.direction = 'down'
          this.computedHeight = 0
          this.inClassLoading = false
        }
      }
    },
    fetchAdjacent() {
      if (inWorking) {
        return
      }
      inWorking = true
      this.inClassLoading = true
      setTimeout(() => {
        this.$emit('classSwitch', {
          direction: this.direction
        })
        inWorking = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
// 定义动画loadingRotate
@keyframes loadingRotate {
  from {
    // 动画开始状态
    transform: rotate(0);
  }
  to {
    // 动画结束状态
    transform: rotate(360deg);
  }
}

.main-list-nomore {
  margin-top: 10px;

  font-size: 0.24rem;
  text-align: center;
  color: #ccc;

  p {
    height: 54px;

    line-height: 54px;
  }
  img {
    margin: 0 0.06rem;

    vertical-align: middle;
  }

  .last-tip {
    margin-top: -10px;

    font-size: 0.22rem;
    color: #999999;
  }
}

.empty-list {
  position: absolute;
  top: 20%;
  left: -7px;

  width: 100%;
  img {
    display: block;

    width: 54%;
    margin: 0 auto;
  }
  p {
    margin-top: 12px;

    font-size: 16px;
    text-align: center;
    color: #b8c2b8;
  }
}

.main-list-top {
  position: relative;

  font-size: 0.22rem;
  text-align: center;
  color: #999999;

  p {
    position: absolute;
    bottom: 0;
    left: 0;

    width: 100%;
    height: 54px;

    line-height: 54px;
    img {
      margin: 0 0.06rem;

      vertical-align: middle;
    }
  }
}

.list-bar {
  width: 100%;
  overflow: scroll;

  background-color: #fff;

  flex: 1;

  @include opacity-show;
  &.in-class-loading {
    &:before {
      display: block;

      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;

      content: '';
    }
  }

  .loading {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);

    .load-img {
      display: flex;

      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .circle {
      width: 0.32rem /* 16/50 */;
      height: 0.32rem /* 16/50 */;
      // 调用动画loadingRotate
      animation: loadingRotate 1s infinite linear;
    }

    .loading-text {
      margin-top: 0.04rem;

      color: #c8c9cc;
    }
  }
}

.li-container {
  position: relative;
}
</style>
